<template>
  <div class="shop-wallet-recharge">
    <div class="filter-bar">
      <select v-model="filters.status" class="filter-select">
        <option value="">全部状态</option>
        <option value="0">待审核</option>
        <option value="1">已通过</option>
        <option value="-1">已驳回</option>
      </select>
      <input v-model="filters.keyword" class="filter-input" placeholder="申请单号 / 店家名称" @keyup.enter="loadList" />
      <button class="btn btn-primary" @click="loadList">查询</button>
      <button class="btn btn-default" @click="resetFilters">重置</button>
    </div>

    <table class="data-table">
      <thead>
        <tr>
          <th>申请单号</th>
          <th>店家</th>
          <th>金额</th>
          <th>状态</th>
          <th>店家备注</th>
          <th>审核备注</th>
          <th>提交时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.transaction_no }}</td>
          <td>
            <span v-if="item.shop">{{ item.shop.name }}</span>
            <span v-else>-</span>
          </td>
          <td class="amount">+{{ (item.amount / 100).toFixed(2) }}</td>
          <td>
            <span :class="['status-tag', statusText(item.status).cls]">{{ statusText(item.status).text }}</span>
          </td>
          <td class="remark">{{ item.remark || '-' }}</td>
          <td class="remark">{{ item.audit_remark || '-' }}</td>
          <td>{{ item.created_at }}</td>
          <td>
            <template v-if="item.status === 0">
              <button class="btn btn-approve" @click="handleApprove(item)">通过</button>
              <button class="btn btn-reject" @click="handleReject(item)">驳回</button>
            </template>
            <span v-else class="muted">已处理</span>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="8" class="empty">暂无数据</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" v-if="total > 0">
      <button class="page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button class="page-btn" :disabled="currentPage >= totalPages" @click="changePage(currentPage + 1)">下一页</button>
    </div>
  </div>
</template>

<script>
import { getShopWalletRecharges, approveShopWalletRecharge, rejectShopWalletRecharge } from '@/api/shop-wallet-recharge'

export default {
  name: 'ShopWalletRechargeAudit',
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      filters: {
        status: '',
        keyword: ''
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / 20) || 1
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async loadList() {
      try {
        const params = {
          page: this.currentPage,
          status: this.filters.status !== '' ? this.filters.status : undefined,
          keyword: this.filters.keyword || undefined
        }
        const res = await getShopWalletRecharges(params)
        const paginator = res.data || {}
        this.list = paginator.data || []
        this.total = paginator.total || this.list.length
      } catch (e) {
        this.$message && this.$message.error('加载失败')
      }
    },
    resetFilters() {
      this.filters = { status: '', keyword: '' }
      this.currentPage = 1
      this.loadList()
    },
    changePage(page) {
      this.currentPage = page
      this.loadList()
    },
    statusText(status) {
      if (status === 1) return { text: '已通过', cls: 'success' }
      if (status === -1) return { text: '已驳回', cls: 'failed' }
      if (status === 0) return { text: '待审核', cls: 'pending' }
      return { text: '未知', cls: '' }
    },
    async handleApprove(item) {
      if (!window.confirm(`确认通过单号 ${item.transaction_no} 的充值申请并入账？`)) return
      try {
        const res = await approveShopWalletRecharge(item.id)
        if (res.code === 0) {
          this.$message && this.$message.success('审核通过，已入账')
          this.loadList()
        } else {
          this.$message && this.$message.error(res.message || '操作失败')
        }
      } catch (e) {
        this.$message && this.$message.error('操作失败')
      }
    },
    async handleReject(item) {
      const remark = window.prompt(`驳回单号 ${item.transaction_no}，请输入驳回原因：`)
      if (remark === null) return
      try {
        const res = await rejectShopWalletRecharge(item.id, { audit_remark: remark })
        if (res.code === 0) {
          this.$message && this.$message.success('已驳回')
          this.loadList()
        } else {
          this.$message && this.$message.error(res.message || '操作失败')
        }
      } catch (e) {
        this.$message && this.$message.error('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  align-items: center;
}
.filter-input,
.filter-select {
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.data-table th,
.data-table td {
  padding: 11px 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}
.data-table th {
  background: #fafafa;
  font-weight: 600;
}
.data-table tr:hover td {
  background: #f9faff;
}
.data-table .amount {
  font-weight: 600;
  color: #ff6b35;
}
.data-table .remark {
  max-width: 200px;
  white-space: normal;
  color: #666;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
.btn {
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  margin-right: 6px;
}
.btn-primary {
  background: #667eea;
  color: #fff;
}
.btn-default {
  background: #eee;
  color: #333;
}
.btn-approve {
  background: #2ecc71;
  color: #fff;
}
.btn-reject {
  background: #e74c3c;
  color: #fff;
}
.muted {
  color: #aaa;
}
.status-tag {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
}
.status-tag.success {
  background: #e8f8f0;
  color: #2ecc71;
}
.status-tag.pending {
  background: #eef4ff;
  color: #e74c3c;
}
.status-tag.failed {
  background: #fdecea;
  color: #e7ea27;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 16px;
}
.page-btn {
  padding: 6px 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 14px;
  color: #666;
}
</style>
